export const GET_TOKEN_ENDPOINT = process.env.NEXT_PUBLIC_TOKEN_URL;
export const SITE = process.env.NEXT_PUBLIC_SITE;
export const GRAPHQL_ENDPOINT = process.env.NEXT_PUBLIC_BACKEND_URL;
export const LOGIN_URL = process.env.NEXT_PUBLIC_LOGIN_URL;
export const PAYFLOW_URL = process.env.NEXT_PUBLIC_PAYFLOW_URL;
export const AWS_URL = process.env.NEXT_PUBLIC_AWS_URL;
export const API_URL = process.env.NEXT_PUBLIC_API_URL;
